import React from "react"
import { TvContainer, TvRow, TvCol, TvDiv } from "@trustvid/design-system"

const Footer = () => {
  return (
    <React.Fragment>
      <TvDiv role="contentinfo" className="footer">
        <TvContainer fluid={true}>
          <TvRow>
            <TvCol md={6}></TvCol>
            <TvCol md={6}>
              <TvDiv className="text-sm-end d-none d-sm-block">
               
              </TvDiv>
            </TvCol>
          </TvRow>
        </TvContainer>
      </TvDiv>
    </React.Fragment>
  )
}

export default Footer
